<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <div class="d-flex content-action align-items-center">
                <div class="input-group border-bottom position-relative" style="width: 190px">
                    <input
                        class="form-control bg-transparent border-none pr-4"
                        :placeholder="$t('common.search')"
                        aria-label="Search"
                        v-model="searchKeyword"
                        style="min-width: 190px"
                    />
                    <i
                        class="fa fa-search position-absolute"
                        style="top: 50%; right: 4px; margin-top: -6px"
                    />
                </div>
                <div class="mx-3 font-20">|</div>
                <div class="d-flex align-items-center text-nowrap">
                    <b-button variant="outline-primary" @click="openCreateModal">
                        <i class="fa fa-plus-circle mr-2"></i>
                        <span class="text-uppercase">Tạo mới</span>
                    </b-button>
                </div>
            </div>
            <b-table
                class="mt-2"
                striped
                hover
                :items="listData"
                :fields="fields"
                show-empty
                :filter="searchKeyword"
                :filter-included-fields="['name']"
            >
                <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
                <template v-slot:cell(pathEn)="data">{{ data.value.split('/')[1] }}</template>
                <template v-slot:cell(pathVi)="data">{{ data.value.split('/')[1] }}</template>
                <template v-slot:cell(pathDe)="data">{{ data.value.split('/')[1] }}</template>
                <template v-slot:cell(createdAt)="data">
                    <span>{{ data.value | formatDateTime }}</span>
                </template>
                <template v-slot:cell(actions)="row">
                    <b-button
                        variant="primary"
                        class="mr-1 min-width-none"
                        @click="openEditModal(row.item)"
                        v-b-tooltip.hover
                        :title="$t('common.edit')"
                    >
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button
                        variant="danger"
                        @click="confirmDelete(row.item)"
                        v-b-tooltip.hover
                        class="min-width-none"
                        :title="$t('common.delete')"
                    >
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
                <template v-slot:empty>
                    <div class="text-center">
                        <span>Không có dữ liệu</span>
                    </div>
                </template>
            </b-table>
        </div>

        <b-modal
            ref="createOrUpdateModal"
            :title="`${form.id ? $t('common.update') : $t('common.create')}`"
            ok-title="Lưu"
            size="lg"
            @ok="handleCreateOk"
            :cancel-title="$t('common.cancel')"
        >
            <b-form-group label="Tên tiếng Anh">
                <b-form-input
                    maxlength="255"
                    v-model="form.nameEn"
                    v-validate="'required'"
                    placeholder="Tên tiếng Anh"
                    name="nameEn"
                    data-vv-as="Tên tiếng Anh"
                ></b-form-input>
                <div v-show="errors.has('nameEn')" class="validation-message text-danger">
                    {{ errors.first('nameEn') }}
                </div>
            </b-form-group>
            <b-form-group label="Tên tiếng Việt">
                <b-form-input
                    maxlength="255"
                    v-model="form.nameVi"
                    v-validate="'required'"
                    placeholder="Tên tiếng Việt"
                    name="nameVi"
                    data-vv-as="Tên tiếng Việt"
                ></b-form-input>
                <div v-show="errors.has('nameVi')" class="validation-message text-danger">
                    {{ errors.first('nameVi') }}
                </div>
            </b-form-group>
            <b-form-group label="Tác giả">
                <b-form-input
                    maxlength="255"
                    v-model="form.author"
                    v-validate="'required'"
                    placeholder="Tác giả"
                    name="author"
                    data-vv-as="Tác giả"
                ></b-form-input>
                <div v-show="errors.has('author')" class="validation-message text-danger">
                    {{ errors.first('author') }}
                </div>
            </b-form-group>
            <b-form-group label="Năm">
                <b-form-input
                    maxlength="255"
                    v-model="form.year"
                    v-validate="'required'"
                    placeholder="Năm"
                    name="year"
                    type="number"
                    data-vv-as="Năm"
                ></b-form-input>
                <div v-show="errors.has('year')" class="validation-message text-danger">
                    {{ errors.first('year') }}
                </div>
            </b-form-group>
            <b-form-group label="Tệp tin tiếng Anh">
                <b-form-file
                    v-model="fileEn"
                    name="fileEn"
                    placeholder="Chọn tệp tin"
                    drop-placeholder="Kéo tệp tin vào đây"
                ></b-form-file>
                <div v-if="form.pathEn">
                    Tệp tin đã chọn: <b>{{ form.pathEn }}</b>
                    <b-button variant="link" class="text-danger" @click="form.pathEn = null"
                        >Xoá</b-button
                    >
                </div>
            </b-form-group>
            <b-form-group label="Tệp tin tiếng Việt">
                <b-form-file
                    v-model="fileVi"
                    name="fileVi"
                    placeholder="Chọn tệp tin"
                    drop-placeholder="Kéo tệp tin vào đây"
                ></b-form-file>
                <div v-if="form.pathVi">
                    Tệp tin đã chọn: <b>{{ form.pathVi }}</b>
                    <b-button variant="link" class="text-danger" @click="form.pathVi = null"
                        >Xoá</b-button
                    >
                </div>
            </b-form-group>
            <b-form-group label="Tệp tin tiếng Đức">
                <b-form-file
                    v-model="fileDe"
                    name="fileDe"
                    placeholder="Chọn tệp tin"
                    drop-placeholder="Kéo tệp tin vào đây"
                ></b-form-file>
                <div v-if="form.pathDe">
                    Tệp tin đã chọn: <b>{{ form.pathDe }}</b>
                    <b-button variant="link" class="text-danger" @click="form.pathDe = null"
                        >Xoá</b-button
                    >
                </div>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    async mounted() {
        await this.$nextTick();
        this.listData = await this.getList();
    },
    data: function() {
        return {
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'nameEn',
                    label: 'Tên tiếng Anh'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'nameVi',
                    label: 'Tên tiếng Việt'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'author',
                    label: 'Tác giả'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'year',
                    label: 'Năm'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'pathEn',
                    label: 'EN'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'pathVi',
                    label: 'VN'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'pathDe',
                    label: 'DE'
                },
                {
                    thClass: 'fixed-actions-col',
                    key: 'actions',
                    label: this.$i18n.t('common.actions'),
                    thStyle: { width: '100px' }
                }
            ],
            form: {},
            searchKeyword: null,
            listData: [],
            fileEn: null,
            fileVi: null,
            fileDe: null
        };
    },
    methods: {
        ...mapActions({
            getList: 'report/getList',
            create: 'report/create',
            delete: 'report/delete',
            update: 'report/update',
            upload: 'file/upload',
            download: 'file/download',
            createAuditByUser: 'user/createAuditByUser'
        }),
        handleCreateOk(modal) {
            modal.preventDefault();
            this.onSubmit();
        },
        onSubmit() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.submitForm();
                }
            });
        },
        async openEditModal(item) {
            this.form = { ...item };
            this.$refs.createOrUpdateModal.show();
        },
        openCreateModal() {
            this.form = {};
            this.$refs.createOrUpdateModal.show();
        },
        async confirmDelete(item) {
            const result = await this.$bvModal.msgBoxConfirm('Bạn có chắc chắn muốn xoá không?', {
                title: 'Xác nhận',
                okVariant: 'danger',
                okTitle: 'Có',
                cancelTitle: 'Không'
            });
            if (result) {
                await this.delete(item);
                this.listData = await this.getList();
                this.$toaster.success('Xoá thành công');
                this.createAuditByUser({ content: 'Xoá báo cáo' });
            }
        },
        async submitForm() {
            if (this.fileEn) {
                const data = await this.upload({ formData: { file: this.fileEn } });
                this.form.pathEn = data.path;
            }
            if (this.fileVi) {
                const data = await this.upload({ formData: { file: this.fileVi } });
                this.form.pathVi = data.path;
            }
            if (this.fileDe) {
                const data = await this.upload({ formData: { file: this.fileDe } });
                this.form.pathDe = data.path;
            }
            if (this.form.id) {
                await this.update(this.form);
            } else {
                await this.create(this.form);
            }
            this.$toaster.success('Thành công');
            this.createAuditByUser({ content: 'Cập nhật báo cáo' });
            this.listData = await this.getList();
            this.$refs.createOrUpdateModal.hide();
        }
    }
};
</script>
